import { cyrb53 } from "./EncryptDecrypt";
import { getCanvasFingerprint } from "./GenerateCanvasFingerprint";
import { generateTheAudioFingerPrint } from "./generateTheAudioPrints";

export const getCurrentBrowserFingerPrint = () => {

    const isCanvasSupported = () => {
        var elem = document.createElement('canvas');
        return !!(elem.getContext && elem.getContext('2d'));
    }

    const getScreenResolution = () => {
        return (screen.height > screen.width) ? [screen.height, screen.width] : [screen.width, screen.height];
    }

    const hasSessionStorage = () => {
        try {
            return !!window.sessionStorage;
        } catch(e) { return true; }
    }

    const hasLocalStorage = () => {
        try {
            return !!window.localStorage;
        } catch(e) { return true; }
    }

    const hasIndexDb = () => {
        try {
            return !!window.indexedDB;
        } catch(e) { return true; }
    }

    const getTheAudioPrints = new Promise((resolve, reject) => {
        generateTheAudioFingerPrint.run(function (fingerprint) {
            resolve(fingerprint);
        });
    });

    const getDevicePrints = () => {
        let keys = [];
        keys.push(navigator.userAgent);
        keys.push(navigator.language);
        keys.push(screen.colorDepth);
        keys.push(getScreenResolution().join('x'));
        keys.push(new Date().getTimezoneOffset());
        keys.push(hasSessionStorage());
        keys.push(hasLocalStorage());
        keys.push(hasIndexDb());
        //body might not be defined at this point or removed programmatically
        if (document.body){
            keys.push(typeof(document.body.addBehavior));
        } else {
            keys.push(typeof undefined);
        }
        keys.push(typeof(window.openDatabase));
        keys.push(navigator.cpuClass);
        keys.push(navigator.doNotTrack);
        if (isCanvasSupported()){
            keys.push(getCanvasFingerprint());
        }
        //console.log(keys);
        //const keysHash = cyrb53(keys.join('###'), 31)
        //console.log(keysHash);
        return keys.join('###');
    }

    const GenerateFingerprint = new Promise((resolve, reject) => {
        getTheAudioPrints.then((audioChannelResult) => {
            let deviceprint = getDevicePrints()
            let fingerprint = window.btoa(audioChannelResult) + deviceprint;

            //console.log(audioChannelResult);
            //console.log(deviceprint);
            //console.log(fingerprint);

            // using btoa to hash the values to looks better readable
            resolve(cyrb53(fingerprint, 31));
        }).catch(() => {
            let deviceprint = getDevicePrints()
            //console.log(deviceprint);
            // if failed with audio fingerprint then resolve only with canvas fingerprint
            resolve(cyrb53(deviceprint, 31).toString());
        }).catch((error) => {
            //console.error(error)
            reject("Failed to generate the finger print of this browser");
        });

    });

    return GenerateFingerprint;
};

